import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError, catchError, finalize, map } from 'rxjs';
import { LoadingService } from './loader-spinner.service';


/**
 * This class is for intercepting http requests. When a request starts, we set the loadingSub property
 * in the LoadingService to true. Once the request completes and we have a response, set the loadingSub
 * property to false. If an error occurs while servicing the request, set the loadingSub property to false.
 * @class {HttpRequestInterceptor}
 */
@Injectable()
export class HttpRequestLoaderInterceptor implements HttpInterceptor {

  private totalRequests = 0;

  constructor(
    private _loading: LoadingService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this.totalRequests++;
    this._loading.setLoading(true);
    return next.handle(request)
      .pipe(catchError((err) => {        
        return throwError(() => err);
      }))
      .pipe(map((evt) => {        
        return evt;
      }))
      .pipe(
        finalize(() => {
          this.totalRequests--;
          if (this.totalRequests === 0) {            
            this._loading.setLoading(false);
          }
        })
      );
  }

  // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
  //   this._loading.setLoading(true, request.url);
  //   return next.handle(request)
  //     .pipe(catchError((err) => {
  //       this._loading.setLoading(false, request.url);
  //       return throwError(err);
  //     }))
  //     .pipe(map((evt) => {
  //       if (evt instanceof HttpResponse) {
  //         this._loading.setLoading(false, request.url);
  //       }
  //       return evt;
  //     }));
  // }
}
